import React, {useState} from "react";
import {Button} from "primereact/button";
import InfoLabel from "../../Label/InfoLabel";
import {
    downloadExcel,
    downloadHTMLValidationReportAsZip,
    downloadValidationReportZip
} from "../../../../../../api/file/download-service";
import {showError} from "../../../../../../api/notification/ToastManager";
import classes from "../../DataProvisioning/DataProvisionning.module.css";
import {ProgressBar} from "primereact/progressbar";
import {TopicProfile} from "../../../../../../enums/TopicProfile";

const ValidationReport = ({
                              filePath,
                              btnStyle,
                              status,
                              summary,
                              validationMsg,
                              validationMsgStyle,
                              validationResultContainWarnings,
                              categoryId,
                              marketNode,
                              uploadMethod
                          }) => {
    const [downloadProgress, setDownloadProgress] = useState({
        progress: 0,
        isDownloading: false,
        status: "",
        mode: "determinate"
    })

    const [isReportDownloading, setIsReportDownloading] = useState(false)

    function getOnDownloadProgress(progressEvent) {
        const total = progressEvent.total || 1
        const completed = Math.round((progressEvent.loaded * 100) / total);
        setDownloadProgress({
            isDownloading: true,
            progress: completed,
            status: `Downloading the file : ${completed}%`,
            mode: "determinate"
        })
    }
    const isBlocked = uploadMethod === "zip-xml" && summary?.toString().startsWith(TopicProfile.MISSING_TOPIC);
    const fileName = filePath !== null ? filePath.replace(/^.*[\\\/]/, '') : "";

    const downloadValidationReportByPath = async () => {
        if (isBlocked) {
            return;
        }
        setIsReportDownloading(true)
        let fileNameWithoutExtension = fileName.split(".")[0];
        try {
            setDownloadProgress({
                isDownloading: true,
                progress: 0,
                status: `Compressing the file`,
                mode: "determinate"
            })
            if (fileName.toLowerCase().endsWith(".xlsx")) {
                await downloadExcel(fileNameWithoutExtension + status + ".xlsx", filePath);
            } else if (fileName.toLowerCase().endsWith(".zip")) {
                await downloadValidationReportZip({
                        "filename": fileName,
                        "filePath": filePath
                    }, fileName,
                    getOnDownloadProgress)
            } else if (fileName.toLowerCase().endsWith(".html")) {
                await downloadHTMLValidationReportAsZip({
                        "filename": fileName,
                        "categoryID": categoryId,
                        "marketNodeID": marketNode.id
                    }, fileNameWithoutExtension + ".zip",
                    getOnDownloadProgress)
            } else {
                showError("Error", `An error occurs when downloading validation Report.`);
            }
            setDownloadProgress({isDownloading: false, progress: 0, status: "", mode: "determinate"})
            setIsReportDownloading(false)
        } catch (e) {
            setIsReportDownloading(false)
            showError("Error", `An error occurs when downloading validation Report.`);
        }
    }

    return (filePath !== null && filePath !== '') ?
        <div>
            <div className="flex flex-column align-items-center">

                <Button label="Report"
                        onClick={downloadValidationReportByPath}
                        className={btnStyle}
                        icon="pi pi-download"
                        iconPos="left"
                        tooltip={summary}
                        disabled={isReportDownloading}
                        tooltipOptions={{position: 'top'}}
                />
                {downloadProgress.isDownloading && <div>
                    <ProgressBar style={{height: "5px", marginTop: "1px"}} color={"#487c84"}
                                 value={downloadProgress.progress} showValue={false}
                                 mode={downloadProgress.mode}
                    />
                    <div className={"flex justify-content-center"}>
                        <span style={{fontSize: "12px"}}>{downloadProgress.status}</span>
                    </div>
                </div>}
            </div>

            {validationResultContainWarnings ?
                <div>
                    <span className="pi pi-exclamation-triangle pl-1" style={{color: "orange"}}/>
                    <small className={classes.small}>Validation report contain some warnings</small>
                </div> : null}

        </div>
        : <InfoLabel textStyle={validationMsgStyle} message={validationMsg}/>;
}
export default ValidationReport;
